/** @jsx jsx */

import { Spacer, Text } from '@zapier/design-system';
import { css, jsx } from '@emotion/core';

import Page from './Page';

const Styles = {
  emoji: css`
    font-size: 60px;
    height: auto;
    width: 60px;
  `,
  root: css`
    text-align: center;
  `,
};

type Props = {
  name: string;
};

function SuccessView(props: Props) {
  const { name } = props;

  return (
    <Page css={Styles.root}>
      <Text tag="h1" type="SectionHeader">
        Request successfully submitted!
      </Text>
      <Spacer height={40} />
      <span aria-labelledby="tada" css={Styles.emoji} role="img">
        🎉
      </span>
      <Spacer height={40} />
      <Text tag="p">
        You will receive an email invite to join {name} as a Collaborator.
      </Text>
    </Page>
  );
}

export default SuccessView;
